import React, { useState } from "react";
import ClickAwayListener from "react-click-away-listener";
import "./ButtonSelect.scss";

function ButtonSelect({ list, onSaveList, onSpot }) {
  const [open, setOpen] = useState(false);
  const [firstBtn, setFirstBtn] = useState("opened");
  const [secondBtn, setSecondBtn] = useState("closed");

  const spotHandler = () => {
    onSpot("Spot");
    setSecondBtn("closed");
    setFirstBtn("opened");
  };
  const toggler = () => {
    setOpen(!open);
    onSpot("Forward");
    setSecondBtn("opened");
    setFirstBtn("closed");
  };

  const dropDownStatus = open ? "block" : "none";

  function chartListHandler(e) {
    const selectedItem = e.target.value;
    const ChartList = list.map((object) => {
      if (object.marketName === selectedItem) {
        return { ...object, cheked: !object.cheked };
      }
      return object;
    });
    onSaveList(ChartList);
  }

  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <div className="ButtonSelect">
      <div>
        <button
          onClick={spotHandler}
          className={`btn ButtonSelect__white ${firstBtn}`}
        >
          Spot
        </button>
      </div>

      <ClickAwayListener onClickAway={handleClickAway}>
        <div className="dropdown">
          <button
            className={`btn  dropdown-toggle ${secondBtn}`}
            onClick={toggler}
          >
            Forward
          </button>

          <ul
            style={{ display: `${dropDownStatus}` }}
            className="dropdown-menu "
          >
            {list.map((item, index) => {
              return (
                <li className="dropdown-item" key={index}>
                  <div>
                    <input
                      onChange={chartListHandler}
                      checked={item.cheked}
                      className="form-check-input"
                      type="checkbox"
                      value={item.marketName}
                      id={item.marketName}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={item.marketName}
                    >
                      {item.marketName}
                    </label>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </ClickAwayListener>
    </div>
  );
}
export default ButtonSelect;

// <div className="ButtonSelect">
//   <button className="btn ButtonSelect__white">Spot</button>
//   <select className="ButtonSelect__select" name="Forward" id="">
//     <option>Forward</option>
//     <option>Forward</option>
//     <option>Forward</option>
//   </select>
// </div>
